import { getKeycloak } from './keycloak-instance';

export interface AuthState {
  authenticated: boolean;
  /** Realm roles do token (realm `admin`) — usadas pelo gate de leitura da UI. */
  roles: string[];
  /** `true` se o usuário tem a role `admin` (o Core é a autoridade real; isto só
   *  reflete o botão de edição — não-admin vê a tela em leitura). */
  isAdmin: boolean;
}

/**
 * Lê o estado de autenticação do singleton do Keycloak.
 * Síncrono: o estado é estável depois que o app renderiza além do KeycloakGate.
 */
export function useAuth(): AuthState {
  const kc = getKeycloak();
  const roles = kc.tokenParsed?.realm_access?.roles ?? [];
  return {
    authenticated: kc.authenticated ?? false,
    roles,
    isAdmin: roles.includes('admin'),
  };
}
